import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { RelationshipPdfTaskItem } from '../RelationshipPdfTaskItem/RelationshipPdfTaskItem';
export const GetTaskItemTID = (parentTestId)=>getTestIds(parentTestId);
export const TaskItem = (param)=>{
    let { task, cancelTask } = param;
    const { TaskItemTID } = useMemo(()=>GetTaskItemTID(task.jobId), [
        task.jobId
    ]);
    switch(task.kind){
        case 'relationshipPdf':
            return /*#__PURE__*/ _jsx(RelationshipPdfTaskItem, {
                task: task,
                cancelTask: cancelTask,
                testId: TaskItemTID.Root()
            });
        default:
            {
                const _exhaustive = task.kind;
                return _exhaustive;
            }
    }
};
